
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.333 10h7.334V8.167H4.333V10zm0-3.667h7.334V4.5H4.333v1.833zM15.288 17.77l-3.713-4.836a2.665 2.665 0 00-.962-.813 2.728 2.728 0 00-1.238-.287H.667V2.667c0-.505.18-.936.538-1.295.36-.36.79-.539 1.295-.539h11c.504 0 .936.18 1.295.539.359.359.538.79.538 1.295v14.666a1.982 1.982 0 01-.045.436zM2.5 19.167c-.504 0-.936-.18-1.295-.539a1.765 1.765 0 01-.538-1.295v-3.666h8.708c.153 0 .294.034.424.103.13.069.24.164.332.286l3.85 5.042a.853.853 0 01-.24.057 2.674 2.674 0 01-.24.012h-11z"}})])
          )
        }
      }
    